import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { toast } from "react-toastify";
import "../components/Table/Table.css";

import {
  subassets,
  getAmenitiesType,
  getdistictName,
  getAmenityCountsData,
  getGCB,
} from "../api/Users";
import axios from "../api/constant";
import {
  get_actual_ideal_shortage_count,
  get_allocated_limit_for_amenity_sub_type,
  get_allocated_limit_used_for_amenity_sub_type,
  AddHostelRequirement,
  get_let_long,
} from "../api/Products";

const HostelRequirement = ({ role, userData }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
  const [AssetsType, setAssetsType] = useState("");
  const [AssetSubtype, setAssetSubtype] = useState("");
  const [QuantityHandle, setQuantityHandle] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [postAmenityName, setPostAmenityName] = useState("");
  const [postAmenitySubName, setPostAmenitySubName] = useState("");
  const [counts, setCounts] = useState({
    actual_count: 0,
    ideal_count: 0,
    shortage_count: 0,
  });
  const [enable, setEnable] = useState(false);
  const [checked, setChecked] = useState(false);
  const [gbcType, setGcbType] = useState("");
  const [gcb, setGcb] = useState([]);
  const [yearsCons, setYearsCons] = useState([]);
  const [yearCons, setYearCons] = useState("");
  const [hostels, setHostels] = useState([]);
  const [hostelType, setHostelType] = useState("");

  const [datasByRow, setDatasByRow] = useState([]);
  const [datas, setDatas] = useState(datasByRow);

  const handleCreate = () => {
    if (!QuantityHandle || !AssetSubtype || !AssetsType) {
      toast.error("Please Fill All The Fields First!");
      return;
    }
    setAssetsType("");
    setAssetSubtype("");
    setQuantityHandle("");
    setCounts({
      actual_count: 0,
      ideal_count: 0,
      shortage_count: 0,
    });

    const newRow = {
      Amenity_Type: postAmenityName,
      Amenity_Sub_Type: postAmenitySubName,
      Amenity_TypeId: AssetsType,
      Amenity_Sub_TypeId: AssetSubtype,
      Ideal_Count: counts.ideal_count,
      Actual_Count: counts.actual_count,
      Shortage_Count: counts.shortage_count,
      Quantity: QuantityHandle,
    };

    setDatas([...datas, newRow]);
    setDatasByRow([...datasByRow, newRow]);
  };

  const handleDelete = (index) => {
    const updatedDatas = datas.filter((_, i) => i !== index);
    setDatas(updatedDatas);
  };

  const onloadApis = () => {
    get_let_long(userData.data.gm_id).then((res) => {
      if (res.status == "success") {
        setLatitude(res.data[0].latitude);
        setLongitude(res.data[0].longitude);
      }
    });

    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log(res.data);
          console.log(res.data);
          setAssetsTypes(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });

    getGCB()
      .then((res) => {
        if (res.status === "success") {
          setGcb(res.data.student_gbc_master);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    onloadApis();
  }, []);

  const handleHostelType = (event) => {
    setHostelType(event.target.value);
  };

  const handleGCBChange = (e) => {
    setGcbType(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: e.target.value,
    };
    axios
      .post("/get_year_of_cons_from_gbc_udise", data)
      .then((response) => {
        if (response.data.status == "success") {
          setYearsCons(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  useEffect(() => {
    onloadApis();
    addRow();
  }, []);

  const AssetTypehandle = async (e) => {
    setAssetsSubTypes("");
    setAssetSubtype("");

    if (!e) {
      console.error("Empty value received");
      return;
    }

    try {
      setAssetsType(e);

      const amenityName = AssetsTypes.assets_name.find(asset => asset.amenity_id === parseInt(e));
      setPostAmenityName(amenityName.name);

      const response = await subassets({ amenity_id: e });
      if (response) {
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error fetching subassets:", error);
    }
  };

  const addRow = () => {
    const newRow = {
      id: rows.length + 1,
      assetType: "",
      amenitySubType: "",
      QuantityHandle: 0,
    };
    setRows([...rows, newRow]);
  };

  const quantityHandle = (event) => {
    setQuantityHandle(parseInt(event.target.value));
  };

  const handleYear = (e) => {
    setYearCons(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: gbcType,
      yoc: e.target.value,
    };
    axios
      .post("/get_hostel_type_from_udise_gbc_yoc", data)
      .then((response) => {
        if (response.data.status == "success") {
          setHostels(response.data.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const AssetSubtypehandle = async (e) => {
    setAssetSubtype(e);
    const amenity_sub_type_name = AssetsSubTypes.find(asset => asset.amenity_sub_type_id === parseInt(e));
    setPostAmenitySubName(amenity_sub_type_name.name);

    const data = {
      UDISE_code: userData.data.UDISE_code,
      amenities_id: AssetsType,
      amenities_sub_type_id: e,
      hostel_id: hostelType,
    };
    get_actual_ideal_shortage_count(data).then((res1) => {
      if (res1.status === "success" && res1.data.result.length > 0) {
        setCounts({
          actual_count: res1.data.result[0].actual_count ?? 0,
          ideal_count: res1.data.result[0].ideal_count ?? 0,
          shortage_count: res1.data.result[0].shortage_count ?? 0,
        });
      } else {
        setCounts({
          actual_count: 0,
          ideal_count: 0,
          shortage_count: 0,
        });
      }
    });
    setEnable(true);
  };

  const handleClear = () => {
    setGcbType("");
    setYearCons("");
    setHostelType("");
    setAssetsType("");
    setAssetsSubTypes("");
    setQuantityHandle("");
    setChecked(0);
    onloadApis();
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const postData = {
      amenities_id: datasByRow.map((row) => row.Amenity_TypeId),
      amenities_sub_type_id: datasByRow.map((row) => row.Amenity_Sub_TypeId),
      quantity: datasByRow.map((row) => row.Quantity),
      UDISE_code: userData.data.UDISE_code,
      school_id: userData.data.school_id,
      hostel_id: hostelType,
      ideal_count: counts.ideal_count,
      school_name: userData.data.school_name,
      gbc_id: gbcType,
      year_of_const: yearCons,
      amenity_name: datasByRow.map((row) => row.Amenity_Type),
      amenity_sub_type_name: datasByRow.map((row) => row.Amenity_Sub_Type),
      user_id: userData.data.id,
      role_id: userData.data.role_id,
      lat: latitude,
      longitude: longitude,
      tentative_amount: "",
      is_urgent: checked,
      gm_id: userData.data.gm_id,
    };

    try {
      const response = await AddHostelRequirement(postData);
      if (response.status === "success") {
        setIsLoading(false);
        toast.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error adding hostel requirement:", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-4">
        <h5 className="my-4">{t("Raise Requirement")}</h5>

        <form
          onSubmit={(e) => handleSubmitForm(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row" style={{ marginTop: "12px" }}>
            <div className="col-md-4">
              <label className="form-label">
                {t("Block")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                value={userData.data.block_name}
                name="block"
                className="common-input form-select"
                disabled
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">
                {t("School")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                disabled
                name="school"
                value={userData.data.school_name}
                className="form-control"
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("UDISE code")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                disabled
                name="udise_code"
                value={userData.data.UDISE_code}
                className="form-control"
                required
              />
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">
                {t("GBC Type")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="gbc_type"
                value={gbcType}
                className="common-input form-select"
                onChange={handleGCBChange}
                required
              >
                <option value="">{t("Select GBC Type")}</option>
                {gcb.map((item) => (
                  <option value={item.id}>{t(item.type)}</option>
                ))}
              </select>
            </div>

            <div className="col-md-4 mt-3">
              <label className="form-label">
                {t("Year of Construction")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="yearCons"
                className="common-input form-select"
                value={yearCons}
                onChange={handleYear}
                required
              >
                <option value="">{t("Year of Construction")}</option>
                {yearsCons.map((item) => (
                  <option value={item.year_of_const}>
                    {t(item.year_of_const)}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4 mt-3">
              <label className="form-label">
                {t("Hostel Type")} {<span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="hostelType"
                className="common-input form-select"
                value={hostelType}
                onChange={handleHostelType}
                required
              >
                <option value="">{t("Select Hostel Type")}</option>
                {hostels.map((item) => (
                  <option value={item.hostel_id}>{t(item.hostel_type)}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="row" style={{ marginTop: "12px" }}>
            <div
              className="col-md-4"
              style={{ display: hostelType ? "block" : "none" }}
            >
              <label className="form-label">
                {t("Unique Hostel code")}{" "}
                {<span style={{ color: "red" }}>*</span>}
              </label>
              <select name="uhc" className="common-input form-select" required>
                <option value="">Select Unique Hostel code</option>
                <option value="347/3312/03/01">347/3312/03/01</option>
                <option value="347/3312/03/02">347/3312/03/02</option>
              </select>
            </div>
          </div>
          <div>
            <div className="col-md-12 d-flex justify-content-around align-items-center  mt-3">
              <div className="col-12">
                <div className="col-12 row">
                  <div className="col-11 row" style={{ marginTop: "12px" }}>
                    <div className="col-2">
                      <label className="form-label">
                        {t("Amenity Type")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <select
                        name="asset_type_id"
                        className="common-input form-select"
                        onChange={(e) => AssetTypehandle(e.target.value)}
                        value={AssetsType}
                      >
                        <option value="">{t("Select")}</option>
                        {AssetsTypes.assets_name &&
                          AssetsTypes.assets_name.map((row, index) => (
                            <option value={row.amenity_id}>{row.name}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-2">
                      <label className="form-label">
                        {t("Amenity Sub Type")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <select
                        name="amenity_sub_type_id"
                        onChange={(e) => AssetSubtypehandle(e.target.value)}
                        className="common-input form-select"
                        value={AssetSubtype}
                      >
                        <option value="">{t("Select")}</option>

                        {AssetsSubTypes &&
                          AssetsSubTypes.map((row, index) => (
                            <option value={row.amenity_sub_type_id}>
                              {row.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-2">
                      <label htmlFor="Ideal_Count" className="form-label">
                        {t("Ideal Count")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <input
                        className="form-control"
                        name="Ideal_Count"
                        disabled
                        value={counts.ideal_count}
                      />
                    </div>
                    <div className="col-2">
                      <label htmlFor="Actual_Count" className="form-label">
                        {t("Actual Count")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <input
                        className="form-control"
                        name="Actual_Count"
                        disabled
                        value={counts.actual_count}
                      />
                    </div>
                    <div className="col-2">
                      <label htmlFor="Shortage_Count" className="form-label">
                        {t("Shortage Count")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <input
                        className="form-control"
                        name="Shortage_Count"
                        disabled
                        value={counts.shortage_count}
                      />
                    </div>
                    <div className="col-2">
                      <label htmlFor="asset_quantity" className="form-label">
                        {t("Quantity")}{" "}
                        {<span style={{ color: "red" }}>*</span>}
                      </label>
                      <input
                        type="number"
                        name="asset_quantity"
                        value={QuantityHandle}
                        className="form-control"
                        onChange={quantityHandle}
                        min="0"
                        disabled={!enable}
                      />
                    </div>
                  </div>
                  <div
                    className="col-1"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-end",
                    }}
                  >
                    <button
                      name="submit"
                      type="button"
                      className="btn btn-success"
                      onClick={handleCreate}
                    >
                      {t("Add")}
                    </button>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Amenity Type")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Amenity Sub Type")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Ideal Count")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Actual Count")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Shortage Count")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Quantity")}
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          {t("Action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {datas.map((data, index) => (
                        <tr key={index}>
                          <td style={{ width: "10%" }}>{data.Amenity_Type}</td>
                          <td style={{ width: "10%" }}>
                            {data.Amenity_Sub_Type}
                          </td>
                          <td style={{ width: "10%" }}>{data.Ideal_Count}</td>
                          <td style={{ width: "10%" }}>{data.Actual_Count}</td>
                          <td style={{ width: "10%" }}>
                            {data.Shortage_Count}
                          </td>
                          <td style={{ width: "10%" }}>{data.Quantity}</td>
                          <td style={{ width: "10%" }}>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => handleDelete(index)}
                            >
                              {t("Delete")}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex align-items-center"></div>

          <div className="col-md-12 mt-5 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary mx-2"
              onClick={handleClear}
            >
              {t("Clear")}
            </button>
            <button type="submit" className="btn btn-primary me-0 mx-2">
              {t("Submit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default HostelRequirement;
